import React, { Component } from 'react'
import styled from 'styled-components'

import { unitCurrency } from 'utils'

import IcInvoice from './images/ic-result.component.svg'
import HomeVector from './images/ic-house.component.svg'
import SeeIcon from './images/ic-see.component.svg'
import EditIcon from './images/ic-edit.component.svg'
import WhatsappIcon from './images/ic-whatsapp.component.svg'
import FacebookIcon from './images/ic-facebook.component.svg'
import XIcon from './images/ic-x.component.svg'
import MailIcon from './images/ic-mail.component.svg'
import IcInfo from './images/ic-info.component.svg'

import ShareButtonV2 from '../ShareButtonV2'
import TooltipV2 from '../TooltipV2'
import ButtonOutlineV2 from '../ButtonOutlineV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import EnergyDetailsV2 from '../EnergyDetailsV2'
import DropdownGhostV2 from '../DropdownGhostV2'
import MobileEditDataModalV2 from '../EditDataModalV2/mobile'

export default class MyTarifMobileSectionV2 extends Component {
  state = {
    shareUrl: `${window.location.origin}${window.location.pathname}?code=${this.props.simulationCode}`,
    shareContent: 'Veja a minha simulação em',
  }

  renderDataModal() {
    const { dataModal, toggleDataModal } = this.props

    return dataModal ? (
      <MobileEditDataModalV2
        {...this.props}
        onClose={toggleDataModal}
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
      />
    ) : null
  }

  renderContent(hasSimulation, content, aditionalCondition = true) {
    return hasSimulation && aditionalCondition ? content : null
  }

  /** Lonely boy */
  render() {
    const {
      hasSimulation,
      annualBilling,
      electricityPriceList,
      electricityConsumption,
      gasPriceList,
      gasConsumption,
      simulationCode,
      prices,
      code,
      router,
      className,
      toggleDataModal,
      ...restProps
    } = this.props

    return (
      <Wrapper className={className} {...restProps}>
        <HeaderRow>
          <h1>O meu Tarifário</h1>
          <ShareWrapper>
            <DropdownGhostV2 titleArea={<ShareButtonV2 />}>
              <div style={{ width: '186px', border: '1px solid #ECECEC' }}>
                <ShareBtn
                  href={`https://wa.me/?text=${encodeURIComponent(
                    this.state.shareContent
                  )} ${encodeURIComponent(
                    `${window.location.origin}${window.location.pathname}?code=${this.props.simulationCode}`
                  )}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <WhatsappIcon />
                  <p>Whatsapp</p>
                </ShareBtn>
                <ShareBtn
                  href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    `${window.location.origin}${window.location.pathname}?code=${this.props.simulationCode}`
                  )}&quote=${encodeURIComponent(this.state.shareContent)}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <FacebookIcon />
                  <p>Facebook</p>
                </ShareBtn>
                <ShareBtn
                  href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(
                    this.state.shareContent
                  )}&url=${encodeURIComponent(
                    `${window.location.origin}${window.location.pathname}?code=${this.props.simulationCode}`
                  )}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <XIcon />
                  <p>X</p>
                </ShareBtn>
                <ShareBtn
                  noBorder
                  href={`mailto:?subject=${encodeURIComponent(
                    'Simulação'
                  )}&body=${encodeURIComponent(
                    `${this.state.shareContent} ${window.location.origin}${window.location.pathname}?code=${this.props.simulationCode}`
                  )}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <MailIcon />
                  <p>Mail</p>
                </ShareBtn>
              </div>
            </DropdownGhostV2>
          </ShareWrapper>
        </HeaderRow>

        <SimulationCodeRow>
          <VectorWrapper>
            <HomeVector />
          </VectorWrapper>
          <span className='code'>
            <p>simulação</p>
            {this.renderContent(hasSimulation, <p>#{code}</p>)}
          </span>
        </SimulationCodeRow>

        <DetailsContent>
          <Detail>
            <span className='title'>
              <IcInvoice />
              <p>Fatura</p>
              <TooltipV2
                content={<TooltipText>Valores aproximados médios</TooltipText>}
                arrowLocation='topLeft'>
                <IcInfo />
              </TooltipV2>
            </span>
            <div className='values'>
              <span>
                <h5>Custo Anual</h5>
                <p>{annualBilling && unitCurrency(annualBilling)}€</p>
              </span>
              <span>
                <h5>Custo Mensal</h5>
                <p>{annualBilling && unitCurrency(annualBilling / 12)}€</p>
              </span>
            </div>
          </Detail>

          {this.renderContent(
            hasSimulation,
            <EnergyDetailsV2 energyType='electricity' {...this.props} />,
            electricityPriceList
          )}

          {this.renderContent(
            hasSimulation,
            <EnergyDetailsV2 border={false} energyType='gas' {...this.props} />,
            gasPriceList
          )}
        </DetailsContent>

        <BtnsWrapper>
          <ButtonOutlineV2
            onClick={() =>
              window.open(
                'https://www.poupaenergia.pt/fatura-energia/',
                '_blank',
                'noopener,noreferrer'
              )
            }
            icon={<SeeIcon />}>
            Como Ler a Fatura
          </ButtonOutlineV2>
          <TooltipV2
            style={{ width: '100%' }}
            contentStyle={{
              minWidth: '200px',
            }}
            dialogStyle={{
              marginTop: '10px',
            }}
            content={
              <TooltipText>
                Clique para atualizar os valores da sua simulação com a
                possibilidade de inserir os dados da sua fatura.
              </TooltipText>
            }
            arrowLocation='topLeft'>
            <ButtonGradientV2
              setModalTriggerHeight={this.props.setModalTriggerHeight}
              onClick={toggleDataModal}
              icon={<EditIcon />}>
              Ajustar Valores
            </ButtonGradientV2>
          </TooltipV2>
        </BtnsWrapper>

        {this.renderDataModal()}
      </Wrapper>
    )
  }
}

const TooltipText = styled.h6`
  color: #fff;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  min-width: 160px;
  margin: 0;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`

const HeaderRow = styled.div`
  display: flex;
  height: 50px;
  padding-inline: 20px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-bottom: 1px solid #ececec;

  h1 {
    padding: 12px 0px;
    flex: 1 0 0;
    margin: 0;
    align-self: stretch;
    color: #1d1e22;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  @media screen and (min-width: 800px) {
    padding-inline: 100px;
  }
`

const SimulationCodeRow = styled.div`
  display: flex;
  padding: 8px 20px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  background: linear-gradient(
      0deg,
      rgba(147, 193, 62, 0.2) 0%,
      rgba(147, 193, 62, 0.2) 100%
    ),
    #fff;
  border-bottom: 1px solid #ececec;
  flex-wrap: wrap;

  > .code {
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;

    p {
      color: #006736;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 150% */
      margin: 0;
    }

    p:last-child {
      font-weight: 700;
    }
  }

  @media screen and (min-width: 800px) {
    padding-inline: 100px;
  }
`

const VectorWrapper = styled.div`
  > svg {
    width: 36px;
    height: 36px;
  }
`

const ShareWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`

const DetailsContent = styled.div`
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media screen and (min-width: 800px) {
    padding-inline: 100px;
  }
`

const Detail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 8px;
  border-bottom: 1px solid #ececec;

  > .title {
    display: flex;
    height: 20px;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    align-self: stretch;
    width: 100%;

    p {
      color: #3e3e3e;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; /* 142.857% */
      margin: 0;
    }

    > div {
      height: 19px;
    }
  }

  > .values {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
    width: 100%;

    > span {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;

      h5 {
        color: #676767;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin: 0;
      }

      p {
        color: #1d1e22;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */
        margin: 0;
      }
    }
  }
`

const BtnsWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  padding: 16px 20px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-top: 1px solid #ececec;

  @media screen and (min-width: 500px) {
    flex-direction: row;
  }

  @media screen and (min-width: 800px) {
    padding-inline: 100px;
  }
`

const ShareBtn = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  height: 40px;
  padding: 10px;
  border-bottom: ${({ noBorder }) => (noBorder ? 'none' : '1px solid #ECECEC')};
  background: #fff;
  text-decoration: none;

  cursor: pointer;

  p {
    flex: 1 0 0;
    color: var(--Gray, #3e3e3e);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
`



// WEBPACK FOOTER //
// ./src/components/MyTarifMobileSectionV2/index.js